export const iconFontAwesomeMedicalHealthMortarPestle = (
	<i className="fa-solid fa-mortar-pestle"></i>
);
